import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from "./table";

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'approve.page.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Approval'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

class ApproveUser extends Component {
  componentDidMount(){
    this.props.getusersList(this.props.username);
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: ""
    };
  }

  selectItem = (value)=>{
    console.log(value);
    // this.setState({delUser: value.username,status: value.status,delEmail: value.email})
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />

        <div className="main">
            <div
              className="panel"
              style={{
                width: '60%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <UserTable data={this.props.usersapproveList} selectItem={this.selectItem} />

              <br/>
              <br/>
              <div
                className="button-container"
                style={{ textAlign: 'center' }}
              >
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  // onClick={() => this.props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>
              </div>
            </div>
        </div>
        <Footer />
      </div>
    );
  }
}

ApproveUser.propTypes = {
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(ApproveUser);



// WEBPACK FOOTER //
// ./src/components/views/Approve/index.js